import React from 'react';
import apiUrl from '../Apiurl';

function BrandVoceCliccabile({
    brandSelezionato,
    setBrandFunction,
    setListaProdottiBrand,
    key,
    nomeBrand
}) {

    let nomeBrandDisplay;

    if (nomeBrand === "" || !nomeBrand) {
        nomeBrandDisplay = "NO-BRAND";
    } else {
        nomeBrandDisplay = nomeBrand;
    }

    function nonSonCapaceEquindiFaccioIlGiro() {
        //console.log("imposto questo: "+nomeBrand)
        setBrandFunction(nomeBrand);
        fetch(apiUrl + "/prodotti/show/all/brand/"+nomeBrandDisplay)
          .then(resp => resp.json())
          .then(data => setListaProdottiBrand(data))
    }

    


    return(
        <div className="underline-hover pointer" key={key} >
            { brandSelezionato !== nomeBrandDisplay && <p onClick={nonSonCapaceEquindiFaccioIlGiro}>{nomeBrandDisplay}</p> }
            { brandSelezionato === nomeBrandDisplay && <p onClick={nonSonCapaceEquindiFaccioIlGiro}><strong>{nomeBrandDisplay}</strong></p> }
        </div>   
    )
}


export default BrandVoceCliccabile;



